import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { NotificationManager } from 'react-notifications';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import StarRating from '../../components/shared/Rating';
import appState from '../../state/AppStateContainer';
import moment from "moment";
import 'moment/locale/sv.js';
import 'moment/locale/nb.js';
import 'moment/locale/da.js';
import { ContractIcon, CentralAgreementIcon } from '../../components/svgs';
import TooltipContainer from '../../components/shared/TooltipContainer/TooltipContainer';
import BlockIcon from '@material-ui/icons/Block';
import SupplierBlockedReasons from './supplier-blocked-reasons';
import SupplierControls from '../app-add-supplier/supplier-controls';
import File from '../../components/File/File';
import { FileScope, PrequalificationDecision } from '../../util/appEnum';
import { getImageUrl } from '../../components/shared/ImagePreview/ImagePreview';
import BtButton from '../bt-button/bt-button';
import { ServiceSupplier } from '../../services/service-supplier';
import * as Sentry from "@sentry/react";
import { ServiceDashboard } from '../../services/service-dashboard';
import PlaceSelector from '../page-supplier-presentation/PlaceSelector';
import { ReactComponent as InfoIcon } from '../../assets/svg/InfoIconLight.svg';
import { ReactComponent as VerifiedIcon } from '../../assets/svg/verifiedIcon.svg';
import { ReactComponent as MonitoringIcon } from "../../assets/svg/monitor-icon.svg";
import { useTranslation, Trans } from 'react-i18next';
import Modal from '../../components/shared/Modal/Modal';
import { Form, Mode, readFormFromDB } from '../../components/shared/Form/Form';
import { ServiceSupplierApplicationForm } from '../../services/service-supplier-application-form';
import { ServiceDownload } from '../../services/service-download';

const formatDateTime = (date) => date ? moment(date).locale('sv').format('D MMMM YYYY HH:mm') : '';

const SupplierProfileField = ({ supplierValue, supplierProfileValue, renderValue=x=>x, isMonitored }) => {
  const [t] = useTranslation('supplierDatabase', { keyPrefix: 'supplierDetailPanel.profileField' });

  const monitorTooltip = () => {
    return isMonitored && (
      <TooltipContainer renderReferenceComponent={(className, ref) => (
        <span className={className} ref={ref} style={{ position: 'relative', width: 'fit-content', marginLeft: '8px', }}>
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ verticalAlign: 'bottom', }}><path d="M9 0L11.2249 2.15239L14.2901 1.71885L14.8249 4.76795L17.5595 6.21885L16.2 9L17.5595 11.7812L14.8249 13.2321L14.2901 16.2812L11.2249 15.8476L9 18L6.77508 15.8476L3.70993 16.2812L3.17508 13.2321L0.440492 11.7812L1.8 9L0.440492 6.21885L3.17508 4.76795L3.70993 1.71885L6.77508 2.15239L9 0Z" fill="#E5E7EB"></path></svg>
          <MonitoringIcon style={{
              width: '10px',
              height: '10px',
              position: 'absolute',
              top: 'calc(50% - 3.5px)',
              left: 'calc(4px)',
              color: 'var(--gray-500)',
            }}
          />
        </span>
      )}>
        <div style={{maxWidth: "512px", fontWeight: 400, fontSize: "14px", color: "var(--gray-700)" }}>
          <p style={{ marginTop: 0 }}><b>{t('monitorTooltip.heading', 'Bevakning')}</b></p>
          {t('monitorTooltip.info', 'Leverantören bevakas i Syna.')}
        </div>
      </TooltipContainer>
    )
  }
  if (!supplierProfileValue?.trim()) return <>{renderValue(supplierValue)}{monitorTooltip()}</> ;
  if (!supplierValue?.trim()) return <>{renderValue(supplierProfileValue)}{monitorTooltip()}</>;
  if (supplierValue?.trim() == supplierProfileValue?.trim()) {
    return (<div>
      {renderValue(supplierValue)}
      <TooltipContainer renderReferenceComponent={(className, ref) => <VerifiedIcon className={className} ref={ref} style={{ marginLeft: "8px", verticalAlign: "bottom" }} />}>
        <div style={{maxWidth: "512px", fontWeight: 400, fontSize: "14px", color: "var(--gray-700)" }}>
          <p style={{ marginTop: 0 }}><b>{t('heading', 'Leverantörsprofil')}</b></p>
          {t('info.matchesSuppliersValue', 'Matchar leverantörens egna uppgifter.')}
        </div>
      </TooltipContainer>
      {monitorTooltip()}
    </div>);
  }

  return (<div>
    {renderValue(supplierValue)}
    <TooltipContainer renderReferenceComponent={(className, ref) => <InfoIcon className={className} ref={ref} style={{ marginLeft: "8px" }} />}>
      <div style={{maxWidth: "512px", fontWeight: 400, fontSize: "14px", color: "var(--gray-700)" }}>
        <p style={{ marginTop: 0 }}><b>{t('heading', 'Leverantörsprofil')}</b></p>
        <Trans t={t} i18nKey="info.valueFromSupplier" values={{supplierProfileValue}}>
          Leverantören har angett <span style={{fontWeight: 500, color: "var(--gray-900)"}}>{{supplierProfileValue}}</span>
        </Trans>
      </div>
    </TooltipContainer>
    {monitorTooltip()}
  </div>);
}

const SupplierDetailPanel = ({
  rowData,
  supId,
  tableRef,
  hasSyna,
  hasCreditsafe,
  renderActions,
  checkbox,
  onFeaturedSupplierSubmit,
  history,
}) => {
  const [t] = useTranslation('supplierDatabase', { keyPrefix: 'supplierDetailPanel' });
  const [contacts, setContacts] = useState(rowData.supMember);
  const [showAllFiles, setShowAllFiles] = useState(false);
  const [showAllSupplierProfileFiles, setShowAllSupplierProfileFiles] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [applicationFormVisibility, setApplicationFormVisibility] = useState(false);
  const [supplierApplicationForm, setSupplierApplicationForm] = useState();
  const [loadingSupplierApplicationForm, setLoadingSupplierApplicationForm] = useState(false);

  const supplierProfile = rowData.supplierProfile;

  // Update contacts when rowData changes
  useEffect(() => {
    setContacts(rowData.supMember);
  }, [rowData]);
  const supplierAreaIds = rowData.areaArray.map(a => a._id).sort().join(",");
  const profileAreaIds = supplierProfile?.areas.map(a => a._id).sort().join(",");
  const supplierProfileAreas = (supplierAreaIds != profileAreaIds) ? supplierProfile.areas.map(a => a.name) : [];

  const loadSupplierApplicationForm = async () => {
    if (!rowData.supplierApplicationFormId) {
      return;
    }

    if (!supplierApplicationForm) {
      setLoadingSupplierApplicationForm(true);
      const form = await ServiceSupplierApplicationForm.getSupplierApplicationForm(rowData.supplierApplicationFormId);
      setSupplierApplicationForm(readFormFromDB(form, Mode.READ));
      
      setLoadingSupplierApplicationForm(false);
    }
    setApplicationFormVisibility(true);
  }

  const handleClose = () => {
    if (tableRef?.current)
      tableRef.current.onToggleDetailPanel([0], rowData => <div>{rowData.name}</div>);
  };

  const renderRecommendedContact = d => {
    return (
      <li className="authSign" key={d._id || d.email}>
        <div className="contact-name">
          <div>{d.name}</div>
          <div>{d.title}</div>
        </div>
        <div className="contact-email-and-phone">
          <div>{d.email}</div>
          <div>{d.phone}</div>
        </div>
      </li>
    );
  }

  const renderContactPerson = d => {
    const renderProfileInfo = (d) => {
      const otherEmailAddress = supplierProfile.otherEmailAddresses.find(o => o.email == d.email);
      const contact = supplierProfile.contacts.find(c => c.email == d.email);

      if (contact) {
        const diff = [
          contact.name && contact.name != d.name && <div>{t('profileInfo.diff.label.name', 'Namn')}: {contact.name}</div>,
          contact.title && contact.title != d.title && <div>{t('profileInfo.diff.label.title', 'Titel')}: {contact.title}</div>,
          contact.phone && contact.phone != d.phone && <div>{t('profileInfo.diff.label.phone', 'Telefon')}: {contact.phone}</div>,
        ].filter(x=>x);
        return (
          <div style={{width: "26px"}}>
            <TooltipContainer renderReferenceComponent={(className, ref) => <VerifiedIcon className={className} ref={ref} style={{ marginRight: "8px" }} />}>
              <div style={{maxWidth: "512px", fontWeight: 400, fontSize: "14px", color: "var(--gray-700)" }}>
                {diff.length ? <>
                  {t('profileInfo.diff.intro', 'E-postadressen matchar leverantörens egna uppgifter, men följande uppgifter skiljer sig:')}
                  {diff}
                </> : t('profileInfo.diff.intro', 'Kontaktpersonen matchar leverantörens egna uppgifter.', { context: 'noDiff' })}
              </div>
            </TooltipContainer>
          </div>
        );
      }

      const comment = otherEmailAddress?.comment;
      if (otherEmailAddress?.redirectTo) {
        const supplierProfileContact = supplierProfile.contacts.find(c => c._id == otherEmailAddress.redirectTo);
        const email = supplierProfileContact?.email;
        const contact = contacts.find(c => c.email == email);
        const name = contact?.name ?? supplierProfileContact?.name;
        if (name) {
          return (
            <div style={{width: "26px"}}>
              <TooltipContainer renderReferenceComponent={(className, ref) => <InfoIcon className={className} ref={ref} style={{ marginRight: "8px" }} />}>
                <div style={{maxWidth: "512px", fontWeight: 400, fontSize: "14px", color: "var(--gray-700)" }}>
                  {
                    comment ? (
                      <Trans t={t} i18nKey="profileInfo.otherEmailAddress.redirectTo_withComment" values={{ name, comment }}>
                        Leverantören rekommenderar: Kontakta <span style={{fontWeight: 500, color: 'var(--gray-900)'}}>{{name}}</span> i stället ({{comment}}).
                      </Trans>
                    ) : (
                      <Trans t={t} i18nKey="profileInfo.otherEmailAddress.redirectTo">
                        Leverantören rekommenderar: Kontakta <span style={{fontWeight: 500, color: 'var(--gray-900)'}}>{{name}}</span> i stället.
                      </Trans>
                    )
                  }
                </div>
              </TooltipContainer>
            </div>
          );
        }
      } else if (comment) {
        return (
          <div style={{width: "26px"}}>
            <TooltipContainer renderReferenceComponent={(className, ref) => <InfoIcon className={className} ref={ref} style={{ marginRight: "8px" }} />}>
              <div style={{maxWidth: "512px", fontWeight: 400, fontSize: "14px", color: "var(--gray-700)" }}>
                <Trans t={t} i18nKey="profileInfo.otherEmailAddress.comment" values={{ comment }}>
                  Meddelande från leverantören: <span style={{fontWeight: 500, color: 'var(--gray-900)'}}>{{comment}}</span>
                </Trans>
              </div>
            </TooltipContainer>
          </div>
        );
      }
      return null;
    }

    return (
      <li className="authSign" key={d._id || d.email}>
        <div style={{display:"flex", alignItems: "center"}}>
          {renderProfileInfo(d)}
          <div style={{flexGrow: 1}}>
            <div className="contact-name">
              <div>{d.name}</div>
              <div>{d.title}</div>
            </div>
            <div className="contact-email-and-phone">
              <div>{d.email}</div>
              <div>{d.phone}</div>
            </div>
          </div>
        </div>
      </li>
    );
  };

  const renderTitle = title => (
    <div className="detail-sec-title">
      <span className="detail-sec-title-title">{title}</span>
    </div>
  );

  const renderFileDateAndComment = (item, activeLabel, inactiveLabel, expiresLabel, scope, scopeOptions) => {
    let active = false;
    let end;
    const pickedDate = item.validUntilDate || item.submittedDate;
    if (pickedDate) {
      end = new Date(pickedDate);
      end.setHours(23, 59, 59, 999);
      active = new Date() < end;
    }
    return <React.Fragment>
      <div className="sp-control-row">
        {item.file &&
          <File
            style={{ marginTop: '5px', display: 'flex' }}
            file={item.file.file}
            fileName={item.file.fileName}
            scope={scope ?? FileScope.SupplierFiles}
            scopeOptions={scopeOptions ?? {
              supplierId: supId
            }}
          />
        }
        {(activeLabel || inactiveLabel) && (<div key="indicator">
          {pickedDate && (
            <>
              {active ? (
                <div className="collective-agreementFlag true">
                  <CheckIcon /> {activeLabel}
                </div>
              ) : (
                <div className="collective-agreementFlag false">
                  <CloseIcon /> {inactiveLabel}
                </div>
              )}
            </>
          )}
        </div>
        )}
        {end &&
          <span>{expiresLabel + " " + end.toLocaleDateString()}</span>
        }
      </div>
      <div className="contact-email-and-phone" style={{marginTop: "-14px", marginBottom: "16px"}}>
        {item.comment}
      </div>
    </React.Fragment>
  }

  const renderFrameworkAgreement = (item) => {
    if (!item) return;
    return item && (item.file || item.validUntilDate || item.comment) &&
      <React.Fragment>
        {renderTitle(t('frameworkAgreement.title', 'Ramavtal'))}
        {renderFileDateAndComment(
          item,
          t('frameworkAgreement.activeLabel', 'Aktivt'),
          t('frameworkAgreement.inactiveLabel', 'Utgånget'),
          t('frameworkAgreement.expiresLabel', 'Giltigt till')
        )}
      </React.Fragment>
  }

  const renderLiabilityInsurance = (item, label, fileScope, fileScopeOptions) => {
    if (!item) return;
    return (item?.file?.file || item?.file?.fileName || item?.validUntilDate || item?.comment) &&
      <React.Fragment>
        <b>{label}</b><br/>
        {renderFileDateAndComment(
          item,
          t('liabilityInsurance.activeLabel', 'Aktiv'),
          t('liabilityInsurance.inactiveLabel', 'Utgången'),
          t('liabilityInsurance.expiresLabel', 'Giltig till'),
          fileScope,
          fileScopeOptions
        )}
      </React.Fragment>
  }

  const renderUE2021Form = (item) => {
    if (!item) return;
    return item && (item.file || item.submittedDate || item.comment) &&
      <React.Fragment>
        <b>{t('ue2021.title', 'UE2021')}</b><br/>
        {renderFileDateAndComment(
          item,
          null,
          null,
          t('ue2021.expiresLabel', 'Inskickat')
        )}
      </React.Fragment>
  }

  const addFeaturedSupplierToRegistry = async (supplierId) => {
    setIsLoading(true);
    if (!supplierId) return;

    try {
      const response = await ServiceSupplier.addFeaturedSupplierToRegistry(supplierId);
      onFeaturedSupplierSubmit(response.name);
    } catch (error) {
      const errorMsg = _.get(error, 'response.data.error', t('notification.error.unexpected.description', 'Oväntat fel ({{error}})', { error }));
      NotificationManager.error(errorMsg, t('notification.error.unexpected.title', 'Misslyckat'));
      Sentry.captureException(error);
    } finally {
      setIsLoading(false);
    }
  }

  const showFormButton = <BtButton loaderShow={loadingSupplierApplicationForm} onClick={() => loadSupplierApplicationForm()} color='white' size='xxs'>{t('application.viewForm', 'Visa formulär')}</BtButton>;

  return (
    <div className="sp-row-detail-wrapper-wrapper">
      <div className="sp-row-detail-wrapper-pre">
        <div className="sp-row-detail-wrapper-pre-inner"></div>
      </div>
      <div className="sp-row-detail-wrapper">
        <div className="ar-row">
          <div className="ar-column detail-left-col">
            <div className="detail-sec-title main">
              {checkbox}
              <div onClick={handleClose} style={{ display: 'flex', width: '100%' }}>
                <span className="detail-sec-title-title" style={rowData.isBlacklist ? {color: "var(--gray-400)"} : {}}>
                  {rowData.isBlacklist && (
                    <span className="blacklistWarningHover">
                      <TooltipContainer renderReferenceComponent={(className, ref) => <BlockIcon style={{ verticalAlign: "middle", marginRight: '15px'}} className={className} innerRef={ref} />}>
                        {rowData.reasons?.length > 0 && (
                          <SupplierBlockedReasons reasons={rowData.reasons} />
                        )}
                      </TooltipContainer>
                    </span>
                  )}

                  {(rowData.frameworkAgreement?.file || rowData.frameworkAgreement?.validUntilDate || rowData.frameworkAgreement?.comment) &&
                    <ContractIcon style={{ marginRight: "10px", marginLeft:0, width: "20px", verticalAlign: "middle" }} />
                  }
                  {rowData.centralAgreements?.length > 0 &&
                    <TooltipContainer renderReferenceComponent={
                      (className, ref) => <CentralAgreementIcon color="var(--orange-500)" style={{ marginRight: '10px', marginLeft: '0', flexShrink: 0 }} className={className} innerRef={ref} />
                    }>
                      <div style={{ maxWidth: "300px", fontSize: "14px", color: "var(--gray-700)", fontWeight: 400 }}>
                        {t('centralAgreementInfo', 'Detta centralt upphandlade ramavtal tillhandahålls av Accurator i samarbete med vår partner Procava.')}
                      </div>
                    </TooltipContainer>
                  }
                  <SupplierProfileField supplierProfileValue={supplierProfile.name} supplierValue={rowData.sup_name} isMonitored={rowData.isMonitored} />
                  {rowData.organizationNumber && (<span>, <span style={{fontWeight: "normal"}}>{rowData.organizationNumber}</span></span>)}
                </span>

                {(rowData.isFeatured && appState.getCurrentOrgSlug() !== 'superadmin') && (
                  <BtButton
                    style={{ marginLeft: '16px', fontSize: '14px', cursor: !rowData?.exists ? 'cursor' : 'default' }}
                    loaderShow={isLoading}
                    disabled={rowData?.exists}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (!rowData?.exists) {
                        ServiceDashboard.logRegistryAddition(rowData.sup_id)
                        addFeaturedSupplierToRegistry(rowData.sup_id);
                      }
                  }}>
                    {rowData?.exists ?
                      t('button.alreadyExists', 'Redan tillagt i registret')
                      : (appState.isAdminRole() ? t('button.add', 'Lägg till i registret') : t('button.addApplication', 'Lägg till som ansökan'))}
                  </BtButton>
                )}
              </div>
            </div>
            <div className="sp-action-wrapper">
              {renderActions(supId, rowData)}
            </div>
          </div>
        </div>

        <div className="ar-row">
          <div className="ar-column detail-left-col">
            <div className="detail-left-desc" style={{whiteSpace:"pre-line"}}>
              {supplierProfile.orgNr && (<>
                {renderTitle(t('profileInfo.title', 'Leverantörsprofil'))}
                {supplierProfile.logo && <img style={{ maxWidth: '300px' }} src={getImageUrl(supplierProfile.logo.file, appState.getCurrentOrgSlug(), FileScope.SupplierProfileLogo, { organizationNumber: supplierProfile.orgNr })} />}
                <p>{supplierProfile.presentation}</p>
              </>)}
              {(supplierProfile.places?.length > 0 || rowData.places?.length > 0) && (<>
                {renderTitle(<>{t('profileInfo.places.title', 'Platser')}
                  <TooltipContainer renderReferenceComponent={(className, ref) => {
                    return (
                      <InfoIcon className={className} ref={ref} style={{ marginLeft: "8px", verticalAlign: "bottom" }} />
                    )
                  }}>
                    <div style={{ maxWidth: "400px" }}>{t('profileInfo.places.info', 'Driftsområden kan läggas till av både dig och leverantören. De som leverantören lägger till kommer att prioriteras vid visning.')}</div>
                  </TooltipContainer>
                </>)}
                <PlaceSelector places={supplierProfile.places?.length > 0 ? supplierProfile.places : rowData.places} readonly />
              </>)}
              {renderTitle(t('profileInfo.description.title', 'Om leverantören'))}
              {((!supplierProfile.orgNr || !supplierProfile.logo) && rowData?.logo?.file) && <img style={{ maxWidth: '300px' }} src={getImageUrl(rowData.logo.file, appState.getCurrentOrgSlug(), FileScope.SupplierLogo, {supplierId: supId})} />}
              <p>{rowData.description}</p>
            </div>
            {renderFrameworkAgreement(rowData.frameworkAgreement)}
            {(rowData.website || supplierProfile.website) && (<>
                {renderTitle(t('profileInfo.website.title', 'Webbplats'))}
                <SupplierProfileField
                  supplierProfileValue={supplierProfile.website}
                  supplierValue={rowData.website}
                  renderValue={value => <a href={(value?.includes('://') ? '' : 'https://') + value}>{value}</a>}
                />
            </>)}
            {renderTitle(t('profileInfo.areas.title', 'Yrkesområden'))}
            <div>
              {rowData.area}
              {supplierProfileAreas.length > 0 && (
                <TooltipContainer renderReferenceComponent={(className, ref) => <InfoIcon className={className} ref={ref} style={{ marginLeft: "8px", verticalAlign: "bottom" }} />}>
                  <div style={{maxWidth: "512px", fontWeight: 400, fontSize: "14px", color: "var(--gray-700)" }}>
                    <b>{t('profileInfo.areas.tooltip.title', 'Leverantörsprofil')}</b><br/>
                    {`${t('profileInfo.areas.tooltip.valueFromSupplier', 'Leverantören har angett', {supplierProfileAreas})} `}<span style={{fontWeight: 500, color: 'var(--gray-900)'}}>{supplierProfileAreas.join(', ')}</span>
                  </div>
                </TooltipContainer>
              )}
            </div>
            {rowData?.otherFiles?.length > 0 && (
              <>
                {renderTitle(t('profileInfo.files.title', 'Filer ({{count}})', { count: rowData.otherFiles.length }))}
                <div style={{ display: 'flex', gap: '8px', flexDirection: 'column' }}>
                  {rowData.otherFiles.map((file, index) => (index < 3 || showAllFiles) ? (
                    <TooltipContainer key={index} delayed renderReferenceComponent={(className, ref) => <File className={className} ref={ref} scope={FileScope.SupplierFiles} scopeOptions={{ supplierId: supId }} style={{ width: 'fit-content', placeItems: 'flex-start' }} file={file.file || ''} fileName={file.fileName} disabled={!file.file} />}>
                      {file.uploadedBy && file.uploadedAt ? <span style={{ whiteSpace: 'nowrap' }}>{t('profileInfo.files.fileInfo', 'Tillagd {{uploadedAt}} av {{uploadedBy}}', { uploadedAt: moment(file.uploadedAt).format('YYYY-MM-DD HH:mm'), uploadedBy: file.uploadedBy })}</span> : ''}
                    </TooltipContainer>
                  ) : null)}
                </div>
              </>
            )}
            {rowData?.otherFiles?.length > 3 && !showAllFiles && (
              <a onClick={() => setShowAllFiles(true)} style={{ textDecoration: 'underline', cursor: 'pointer', marginTop: '8px' }}>
                {t('profileInfo.files.showAll', 'Visa alla filer')}
              </a>
            )}
            {rowData?.supplierProfile?.existingFiles?.length > 0 && (
              <>
                {renderTitle(t('profileInfo.files.existingFiles.title', 'Leverantörens filer ({{count}})', { count: rowData.supplierProfile.existingFiles.length }))}
                <div style={{ display: 'flex', gap: '8px', flexDirection: 'column' }}>
                  {rowData.supplierProfile.existingFiles.map((file, index) => (index < 3 || showAllSupplierProfileFiles) ? (
                    <TooltipContainer key={index} delayed renderReferenceComponent={(className, ref) => <File className={className} ref={ref} scope={FileScope.SupplierProfileFile} scopeOptions={{organizationNumber: rowData.organizationNumber}} style={{ width: 'fit-content', placeItems: 'flex-start' }} file={file.file || ''} fileName={file.fileName} disabled={!file.file} />}>
                      {file.uploadedBy && file.uploadedAt ? <span style={{ whiteSpace: 'nowrap' }}>{t('profileInfo.files.existingFiles.fileInfo', 'Tillagd {{uploadedAt}} av {{uploadedBy}}', { uploadedAt: moment(file.uploadedAt).format('YYYY-MM-DD HH:mm'), uploadedBy: file.uploadedBy })}</span> : ''}
                    </TooltipContainer>
                  ) : null)}
                </div>
              </>
            )}
            {rowData?.supplierProfile?.existingFiles?.length > 3 && !showAllSupplierProfileFiles && (
              <a onClick={() => setShowAllSupplierProfileFiles(true)} style={{ textDecoration: 'underline', cursor: 'pointer', marginTop: '8px' }}>
                {t('profileInfo.files.existingFiles.showAll', 'Visa alla leverantörens filer')}
              </a>
            )}

            {renderTitle(t('registration.title', 'Registreringsinformation'))}
            <div>
              {rowData?.application ? (
                <>
                  {rowData?.prequalification?.decidedAt && (<div style={{marginBottom: "16px"}}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
                    {t(
                      'application.prequalificationDecision',
                      'Ansökan: {{context}} den {{decidedAt}} av {{decidedBy}}',
                      {
                        context: rowData?.prequalification.decision,
                        decidedAt: formatDateTime(rowData?.prequalification.decidedAt),
                        decidedBy: rowData?.prequalification.decidedByName
                      }
                    )}
                    {rowData.supplierApplicationFormId && showFormButton}
                  </div>
                  </div>)}
                  {rowData?.prequalification.decision == PrequalificationDecision.INBOX && (<>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
                      {t(
                        'application.inboxed.info', 
                        'Inskickad den {{createdAt}} av {{applicantInfo}}.',
                        {
                          createdAt: formatDateTime(rowData?.createdAt),
                          applicantInfo: [
                            rowData?.application?.applicant?.name,
                            rowData?.application?.applicant?.title,
                            rowData?.application?.applicant?.email,
                            rowData?.application?.applicant?.phone,
                          ].filter(x=>x).join(', ')
                        }
                      )}
                      {rowData.supplierApplicationFormId && showFormButton}
                    </div>
                    
                    {rowData?.application?.message && (<>
                      <p style={{whiteSpace: "pre-line"}}>
                        <span style={{fontWeight: "bold"}}>{t('application.inboxed.messageTitle', 'Meddelande')}</span><br/>
                        {rowData?.application?.message}
                      </p>
                    </>)}
                  </>)}
                  {appState.getCurrentOrgSlug() === 'superadmin' && (<>
                    <div className='sp-control-row' style={{marginTop: 16}}><b>{t('application.label.invoiceAddress', 'Fakturaadress')}</b> {rowData?.application?.invoiceAddress}</div>
                    <div className='sp-control-row'><b>{t('application.label.invoiceReference', 'Märkning/referens')}</b> {rowData?.application?.invoiceReference}</div>
                    <div className='sp-control-row'><b>{t('application.label.invoiceInterval', 'Avtalslängd')}</b> {rowData?.application?.invoiceInterval}</div>
                  </>)}
                </>
              ) : (
                <div style={{marginBottom: "16px"}}>
                  {rowData.importId ? (
                    t(
                      'registration.imported',
                      'Importerad den {{date}}',
                      { date: formatDateTime(rowData.createdAt) }
                    )
                  ) : (
                    t(
                      'registration.created',
                      'Skapad den {{date}}',
                      { context: rowData.createdByName ? 'name' : null, date: formatDateTime(rowData.createdAt), name: rowData.createdByName }
                    )
                  )}
                </div>
              )}
            </div>
          </div>

          <div className="ar-column detail-right-col">
            {renderTitle(t('experience.title', 'Erfarenheter'))}
            <div>
              <div className="sp-control-row">
                <b>{t('experience.rating.title', 'Rekommendationer')}</b>
                { rowData.projectsCount ? (
                  <StarRating className="rating-component" rating={rowData.rating} readOnly />
                ) : (
                  <div>{t('experience.noProjects', 'Inga projekt genomförda')}</div>
                )}
              </div>
              <div className="sp-control-row">
                <b>{t('experience.evaluation.title', 'Utvärderingar')}</b>
                <div>
                  { rowData.projectsCount ? (
                    <a href={`${appState._getCurrentOrgUrl()}/rating/${supId}/true`} className="iconed-btn">
                      <span className="iconed-btn-text">{t('experience.evaluation.button', 'Visa utvärderingar')}</span>
                    </a>
                  ) : (
                    t('experience.noProjects', 'Inga projekt genomförda')
                  )}
                </div>
              </div>
            </div>
            {renderTitle(t('contacts.title', 'Kontaktpersoner'))}
            <div className="details-right-inner">
              <div className="details-right-inner-list">
                <ul>
                  {contacts.map(renderContactPerson)}
                </ul>
              </div>
            </div>
            {supplierProfile.contacts.filter(profileContact => !contacts.find(c => c.email == profileContact.email)).length > 0 && (<>
              {renderTitle(t('recommendedContacts.title', 'Leverantörens föreslagna kontaktpersoner'))}
              <div className="details-right-inner">
                <div className="details-right-inner-list">
                    <ul>
                      {supplierProfile.contacts
                        .filter(profileContact => !contacts.find(c => c.email == profileContact.email))
                        .map(renderRecommendedContact)}
                    </ul>
                </div>
              </div>
            </>)}

          </div>

          <SupplierControls
            organizationNumber={rowData.organizationNumber}
            hasSyna={hasSyna}
            hasCreditsafe={hasCreditsafe}
            history={history}
          >
            {renderLiabilityInsurance(rowData.liabilityInsurance, t('liabilityInsurance.title', 'Ansvarsförsäkring'))}
            {renderLiabilityInsurance(
              supplierProfile.liabilityInsurance,
              t('liabilityInsurance.profileInfoTitle', 'Ansvarsförsäkring från leverantörsprofil'),
              FileScope.SupplierProfileFile,
              {organizationNumber: rowData.organizationNumber}
            )}
            {renderUE2021Form(rowData.ue2021Form)}
          </SupplierControls>
        </div>
      </div>
      <div className="sp-row-detail-wrapper-post">
        <div className="sp-row-detail-wrapper-post-inner"></div>
      </div>
      {rowData.supplierApplicationFormId && supplierApplicationForm && (
        <Modal
          title={t('application.modal.title', 'Formulär')}
          show={applicationFormVisibility}
          setShow={(value) => setApplicationFormVisibility(value)}
        >
          <div style={{ width: '710px' }} onClick={(e) => {
            if (e.target.className == 'supplierApplicationFormFile') {
              e.preventDefault();
              const blobPath = e.target.dataset['file'];
              const mimeType = e.target.dataset['mime'];
              const fileName = e.target.dataset['name'];
              ServiceDownload.downloadFile(blobPath, mimeType, fileName, FileScope.SupplierFiles, {supplierId: rowData.sup_id});
            }
          }}>
            <Form
              form={supplierApplicationForm}
            />
          </div>
        </Modal>
      )}
    </div>
  );
}

export default SupplierDetailPanel;
